import { NavLink, Outlet, useParams } from 'react-router-dom'
import { AppLayout, ErrorBanner, PageHeader } from '@/components/AppLayout'
import { useAsync } from '@/hooks/useAsync'
import { getEvent } from '@/lib/queries'
import { type EventContext } from './eventContext'

const TABS = [
  { to: '.', label: 'Overview', end: true },
  { to: 'attendees', label: 'Attendees', end: false },
  { to: 'form', label: 'Form', end: false },
  { to: 'results', label: 'Results', end: false },
]

export function EventLayout() {
  const { eventId = '' } = useParams<{ eventId: string }>()
  const { data: event, loading, error, reload } = useAsync(() => getEvent(eventId), [eventId])

  if (loading) {
    return (
      <AppLayout>
        <p className="page-status">Loading event…</p>
      </AppLayout>
    )
  }

  if (error !== null || event === null) {
    return (
      <AppLayout>
        <div className="page">
          <ErrorBanner message={error ?? 'That event could not be found.'} />
        </div>
      </AppLayout>
    )
  }

  return (
    <AppLayout>
      <div className="page">
        <PageHeader title={event.name} breadcrumb={<NavLink to="/">Events</NavLink>} />

        <nav className="tabs" aria-label="Event sections">
          {TABS.map((tab) => (
            <NavLink key={tab.label} className="tab" to={tab.to} end={tab.end}>
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <Outlet context={{ event, reloadEvent: reload } satisfies EventContext} />
      </div>
    </AppLayout>
  )
}
